import { render, staticRenderFns } from "./InjectionCharts.vue?vue&type=template&id=2436444e&scoped=true"
import script from "./InjectionCharts.vue?vue&type=script&lang=js"
export * from "./InjectionCharts.vue?vue&type=script&lang=js"
import style0 from "./InjectionCharts.vue?vue&type=style&index=0&id=2436444e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2436444e",
  null
  
)

export default component.exports